import { SlabsComponent } from './../slabs/slabs.component';
import { Subscription } from 'rxjs';
import { Component, Input, OnInit, EventEmitter, OnChanges, SimpleChanges, Output, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ICLientData, ICurrency, IUser } from '../../../../shared/models';
import {
  PaymentService, UtilService, VariablesService, StorageService, EventsService, AuthService, ScriptLoaderService, VwoService, ApiService, PaymentV2Service, PortfolioService
} from '../../../../shared/services';
import { ICart } from '../../models/cart.model';
import { IContribute, IRewards } from '../../models/contribute.model';
import { AMOUNT_FORM } from '../../objects/amount.form';
import { PaymentUtilService } from '../../services';
import { IPaymentParam } from '../../../../shared/models/payment-params.model';
import { IPageConfig } from '../../objects/page.config';
import { MatDialog } from '@angular/material/dialog';
import { ISipCause } from '../../../../fundraiser/models/fundraiser.model';
import { IPaymentConfig } from '../../models/payment.model';

@Component({
  selector: 'app-amount-form',
  templateUrl: './amount-form.component.html',
  styleUrls: ['./amount-form.component.scss']
})
export class AmountFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() campaignId;
  @Input() contributeDetails: IContribute;
  @Input() isReward;
  @Input() config: IPageConfig;
  @Input() isLoading;
  @Input() paymentFlowType;
  @Output() userSelectionCurrency: EventEmitter<ICurrency> = new EventEmitter();
  @Output() isSumbited: EventEmitter<boolean> = new EventEmitter();
  @Input() isRewardSelected;
  @Input() isQR;
  @Input() fixedAmount;
  @Input() eventCause;
  @Input() event;
  @Input() upiMode;
  @Input() onpage;
  @Input() captchaType;
  @Input() skipFailedCase;
  @Input() paymentIcons;
  @Input() recommendTag;
  @Input() inputFields;
  @Input() position;
  @Input() origin;
  @Input() isSipStory;
  @Input() payment_config: IPaymentConfig;
  @Input() tagLabel;
  @Input() theme;
  @Input() miniStory;
  @Output() submitOrder = new EventEmitter();
  /**Forms input */
  amountForm: FormGroup;
  amount;
  name: FormControl;
  mobile: FormControl;
  email: FormControl;
  nationality: FormControl;
  captcha: FormControl;
  address;
  pincode;
  pancard;
  passport;
  is_anonymous: FormControl;
  info = AMOUNT_FORM;
  isMobile: any;

  supportedCurrencies: ICurrency[] = [];
  clientData: ICLientData;
  cartResponse: ICart;
  slabs: any[] = [];
  reward: IRewards;
  currency;
  currencyDetails: ICurrency;
  params: IPaymentParam;
  isLoggedIn;
  geocoder;
  backPressed = false;
  isPanCardExists = false;
  askPassport = false;
  askPincode;
  extn;
  failedTransaction;
  cartValues;
  tipAmount;
  tipPercent;
  baseAmount;
  selectedNationality: any = true;
  initialContributeLoad = false;
  subs: Subscription[] = [];
  @ViewChild('paytmLoginRef', { static: true }) public paytmLogin;
  @ViewChild('captchaRef') captchaRef;
  @ViewChild(SlabsComponent) slabsComponent!: SlabsComponent;
  dialogRef;
  exitCounter = 0;
  enableCaptha = false;
  screen;
  sipAmount = 0;
  isSipCause = false;
  memorialTooltip = false;
  sipCause: ISipCause;
  ngo_sip;
  user: IUser;
  isEdit;
  fromToggleTip = false;
  randomDonorCount = 0;
  max_donation = 50000000;
  bulkdata;
  bulkamount;
  bulkShown = false;
  pancard_regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  is_any_active_sip;
  month_interval;
  addedExtraAmountCount = 0;

  showBulkDonationFor = /^(facebook|fbad|crt|adroll|taboola|tabool|keywee|keeyee|timescol|rtbhouse|Affiliates)$/i;
  showHfMini = false;
  hfExist = false;

  constructor(
    private paymentService: PaymentService,
    public paymentUtilService: PaymentUtilService,
    public utilService: UtilService,
    public vars: VariablesService,
    public router: Router,
    private actiRoute: ActivatedRoute,
    private storageService: StorageService,
    public eventsService: EventsService,
    public authService: AuthService,
    public scriptLoaderService: ScriptLoaderService,
    public vwo: VwoService,
    public dialog: MatDialog,
    private apiService: ApiService,
    public paymentV2: PaymentV2Service,
    private portfolioService: PortfolioService
  ) {
    this.initForm();
    this.params = this.actiRoute.snapshot.queryParams;
  }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.setConfig();
    this.actiRoute.queryParams.subscribe((params) => {
      // if (params.payment === 'form' && this.currency !== 'INR' && this.screen !== params.payment && this.vars.pageName !== 'stories') {
      //   this.toggleCaptcha(true);
      // }
      this.screen = params.payment;
    });
    if (this.fixedAmount) {
      this.amount = this.fixedAmount;
    }
    if (this.contributeDetails?.ngo_sip_campaign) {
      this.isSipCause = true;
      this.ngo_sip = true;
    }
    this.failedTransaction = this.actiRoute.snapshot.queryParams['st'] === 'f';
    this.utilService.number.subscribe({
      next: (res) => {
        if (res && res.extn) {
          this.extn = res.extn;
        }
      }
    });
    this.subs.push(this.vars.clientLocationData.subscribe((res) => this.clientData = res));
    this.subs.push(this.paymentUtilService.paymentCurrency.subscribe({
      next: (res) => {
        this.currency = res;
        this.currencyDetails = this.utilService.getCurrencyIcon(this.currency);
        if (res && res !== 'INR') {
          this.info.pincode.placeholder = 'Zipcode';
          // if (this.vars.pageName !== 'stories') {
          //   this.toggleCaptcha(true);
          // }
        } else {
          this.toggleCaptcha(false);
        }
      }
    }));
    this.utilService.isLoggedIn.subscribe({
      next: (res) => {
        this.isLoggedIn = res;
        this.fillCart();
      }
    });
    setTimeout(() => { this.fillCart(); }, 0);
    this.rewardSelection();
    this.paytmLoginConsent();
    this.subs.push(this.vars.sip_cause.subscribe(
      (res) => {
        this.sipCause = null;
        if (res) {
          this.isSipCause = true;
          this.sipCause = res;
        }
      }
    ));
    this.subs.push(this.vars.onUpiOptionClick.subscribe(res => {
      if (!this.isLoading) {
        this.submitForm();
      }
    }));
    if (this.isQR?.name === 'UPI') {
      this.max_donation = 100000;
    }
    this.is_any_active_sip = this.utilService.checkForActiveSip(this.utilService.getUserData()?.listsubscriptions);
    if (this.campaignId) {
      this.vars.campaignId = this.campaignId;
    }
    if (this.params?.sip_story) {
      this.paymentUtilService.paymentMode = 'recuring';
      this.month_interval = 1;
    }
    if (this.vwo.groww_on_ministoryAB() && this.user) {
      this.getUserOrders();
    }
    if (this.vwo.bulk_donation_hf_mini_AB() && this.user) {
      this.getLatestUserData();
    }
  }

  getLatestUserData() {
    this.authService.getUserProfile().subscribe({
      next: (user: any) => {
        if (user?.data) {
          this.user = user?.data;
          this.utilService.setUserData(this.user);
          this.vars.userData.next(this.user);
          if (this.user?.last_health_first_order?.order_plan?.status_flag === 1 || this.user?.userHealthPolicy?.status === 1) {
            this.hfExist = true;
          }
        }
      },
    });
  }

  getUserOrders() {
    const qparam = `?with=campaign.leaderboard;campaign;campaign.beneficiary;campaign.beneficiaryname;campaign.mediaBeneficiary&limit=1&otd_order=true&orderBy=creation_date&sortedBy=desc`;
    this.portfolioService.getBeneficiaries(qparam).subscribe((res: any) => {
      if (res?.data?.data?.length && res?.data?.data[0]?.campaign) {
        this.vars.prevOrderDetails = res?.data?.data[0];
      }
    });
  }

  setConfig() {
    this.subs.push(this.paymentUtilService.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
      }
    }));
  }

  toggleCaptcha(status) {
    this.enableCaptha = this.controlToggle('captcha', status);
    if (this.captchaRef && this.enableCaptha) {
      this.captchaRef.resetCaptcha();
      this.captchaRef.executeCaptcha();
      this.captcha.setValue('');
    }
  }

  /**Paytm login concent */
  paytmLoginConsent() {
    if (this.vars.isPaytmMini && !this.utilService.getUserData() && this.exitCounter < 3) {
      this.isLoading = true;
      this.paymentService.paytmAuthFetch().then((res: any) => {
        this.isLoading = false;
        if (res.data) {
          this.name.setValue(res.data.profileInfo.displayName || '');
          this.email.setValue(res.data.email || '');
          this.mobile.setValue(res.data.phoneInfo.phoneNumber || '');
        }
      }).catch(() => {
        this.isLoading = false;
        this.exitCounter++;
        if (this.exitCounter >= 3) {
          this.exitPaytm();
        } else {
          this.dialogRef = this.dialog.open(this.paytmLogin);
        }
      });
    }
  }
  /**Exit paytm screen */
  exitPaytm() {
    this.dialog.closeAll();
    ((<any>window).JSBridge).call('popWindow');
  }
  /**There are three ways of prefilling the cart
   * 1. If data present in the URL
   * 2. If the order failed then get cart from session storage
   * 3. If none of above the show the logged in user data
   */
  fillCart() {
    /**if the url comes with the prefilled data of failled cart */
    if (this.actiRoute.snapshot.queryParams['selected_currency']) {
      const cartDataFromLink: ICart = this.actiRoute.snapshot.queryParams;
      this.patchAmountForm(cartDataFromLink);
      /**If transaction failed then the cart details will pull from the session storage */
    } else if (this.storageService.getFromSession('cartData') && !this.vars.thirdPartyApp) {
      const cartData = this.storageService.getFromSession('cartData');
      this.user = this.utilService.getUserData();
      if (this.user?.last_health_first_order?.order_plan?.status_flag === 1 || this.user?.userHealthPolicy?.status === 1) {
        this.hfExist = true;
      }
      if (this.amount) {
        cartData.donated_amount = this.amount;
      }
      cartData.pincode = this.user?.pincode;
      if (this.params.st === 'f') {
        this.patchAmountForm(cartData);
        this.paymentUtilService.paymentCurrency.next(cartData.currency);
        this.paymentUtilService.cartResponse.next(cartData);
        this.paymentV2.paymentConfig.next({ cart: cartData });
        this.subs.push(this.paymentUtilService.backButton.subscribe((res) => {
          if (res) {
            this.backPressed = true;
          }
        }));
        if (!this.backPressed && !this.isQR && !this.skipFailedCase) {
          this.getPaymentOptions(cartData.currency);
        }
      } else {
        this.patchAmountForm(cartData);
      }
      /**If user is logged in */
    } else if (this.utilService.getUserData()) {
      this.user = this.utilService.getUserData();
      this.fillStoryForm(this.user);
    }
  }

  fillStoryForm(userData) {
    if (userData) {
      this.amountForm.patchValue({
        name: userData.full_name,
        mobile: userData.phone_1 === '1111111111' ? null : userData.phone_1,
        email: userData.email,
      });
    }
    if (userData?.address_1) {
      this.amountForm.patchValue({
        address: userData?.address_1 || ''
      });
    }
    if (userData?.pan_number?.info_1) {
      this.controlToggle('pancard', true, this.pancard_regex, userData?.pan_number?.info_1);
    }
    if (userData?.pincode) {
      this.amountForm.patchValue({
        pincode: userData?.pincode
      });
    }
  }

  rewardSelection() {
    this.subs.push(this.paymentUtilService.selectedReward.subscribe(reward => {
      if (reward) {
        this.reward = reward;
        this.isRewardSelected = true;
        this.isReward = true;
        this.amount = reward.amount;
      }
    }));
  }

  patchAmountForm(cartData: any) {
    this.cartValues = cartData;
    this.amount = cartData.donated_amount_local || cartData.donated_amount;
    this.amountForm.patchValue({
      amount: cartData.donated_amount,
      name: cartData.donor_name,
      is_anonymous: cartData.is_anonymous,
      mobile: cartData.donor_phone === 1111111111 ? this.mobile.reset() : cartData.donor_phone,
      email: cartData.donor_email,
      address: cartData.donor_address,
      pancard: cartData.pan,
      passport: cartData.passport,
      nationality: cartData.indian,
      pincode: cartData?.pincode
    });
    if (cartData.passport) {
      this.nationalityChange();
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.contributeDetails && changes.contributeDetails !== undefined && changes.contributeDetails.currentValue) {
      this.getContributeFormDetails();
    }
  }

  /**Init the form */
  initForm() {
    this.amountForm = new FormGroup({
      name: this.name = new FormControl('', [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.minLength(3)]),
      is_anonymous: this.is_anonymous = new FormControl(false),
      mobile: this.mobile = new FormControl('', Validators.required),
      email: this.email = new FormControl('', [
        Validators.required, Validators.pattern(this.vars.email_Pattern_Regex)
      ]),
    });
  }

  setAmount(data) {
    setTimeout(() => {
      this.baseAmount = +data;
      this.checkPanMinAmt(data);
      this.setTotalAmount();
    }, 0);
  }

  checkPanMinAmt(data) {
    if (data >= this.contributeDetails.pan_required_amount && this.contributeDetails.ask_pan && this.selectedNationality !== '0') {
      this.isPanCardExists = this.controlToggle('pancard', true, this.pancard_regex, this.user?.pan_number?.info_1);
      return true;
    } else {
      this.isPanCardExists = this.controlToggle('pancard', false);
      return false;
    }
  }

  /**Set the tip amount  */
  setTipAmount(data) {
    setTimeout(() => {
      this.tipAmount = +data;
      this.setTotalAmount();
    }, 0);
  }

  setTotalAmount() {
    if (this.storageService.getFromSession('india')) {
      this.setAmountNudge(this.contributeDetails?.selected_currency === 'INR' ? 200 : this.contributeDetails.min_donation);
    }
    this.amount = (+this.baseAmount || 0) + (+this.tipAmount || 0) + (+this.independeceAmount || 0);
  }

  /**Set the tip amount for last tip try   */
  setLastTipAmt(data) {
    setTimeout(() => {
      this.fromToggleTip = true;
      this.tipAmount = data.tipAmt;
      this.amount = data.baseAmt + data.tipAmt;
    }, 0);
  }

  /**Set the tip percent  */
  setTipPercent(data) {
    this.tipPercent = data;
  }

  /**Set the user selected currency */
  setCurrency(data: ICurrency) {
    this.userSelectionCurrency.emit(data);
  }
  /**Is submit true */
  setIsSubmit() {
    this.router.navigate([], {
      queryParams: { payment: 'options', op: this.isMobile && this.currency !== 'INR' ? 'c' : null },
      queryParamsHandling: 'merge'
    });
  }

  // Nationality change event
  nationalityChange() {
    if (this.selectedNationality === '0' && this.contributeDetails.ask_passport) {
      this.askPassport = this.controlToggle('passport', this.contributeDetails.ask_passport, /(^[a-zA-Z0-9]{2,20}$)/);
      this.isPanCardExists = this.controlToggle('pancard', false);
    } else if (this.selectedNationality === true && this.contributeDetails.ask_pan && this.checkPanMinAmt(this.baseAmount)) {
      this.isPanCardExists = this.controlToggle('pancard', this.contributeDetails.ask_pan, /[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/g);
      this.askPassport = this.controlToggle('passport', false);
    } else {
      this.askPassport = this.controlToggle('passport', false);
      this.isPanCardExists = this.controlToggle('pancard', false);
    }
  }
  submitFromUserInfo(data) {
    this.is_anonymous.setValue(data.is_anonymous);
    this.submitForm();
  }

  submitBulk = (event) => {
    this.bulkShown = true;
    this.bulkdata = null;
    this.bulkamount = null;
    this.vars.selectedHfMiniPlan = null;
    try {
      if (Object.keys(event).length > 0) {
        this.bulkdata = {
          [this.campaignId]: { amount: this.amount }, ...event
        };
        this.bulkamount = Object.values(this.bulkdata).reduce((a, { amount }) => a + amount, 0);
        if (this.bulkdata[this.vars.hfMiniPlans.id]) {
          this.vars.selectedHfMiniPlan = {
            plan_id: this.vars.hfMiniPlans.id,
            amount: this.vars.hfMiniPlans.amount
          }
        }
      }
    } catch (error) { }
    this.submitPayment();
  }

  submitHfMini = (e) => {
    if (e) {
      this.bulkdata = {
        [this.campaignId]: { amount: this.amount },
        [this.vars.hfMiniPlans.id]: { amount: this.vars.hfMiniPlans.amount }
      };
      this.bulkamount = Object.values(this.bulkdata).reduce((a, { amount }) => a + amount, 0);
      this.vars.selectedHfMiniPlan = {
        plan_id: this.vars.hfMiniPlans.id,
        amount: this.vars.hfMiniPlans.amount
      }
    } else {
      this.bulkdata = null;
      this.vars.selectedHfMiniPlan = null;
    }
    if (this.vwo.hf_mini_AB()) {
      this.submitPayment();
    }
  }

  captchaResponse(e) {
    this.paymentV2.captchaResponse = e;
    this.submitPayment();
  }

  submitPayment() {
    if (!this.paymentV2.captchaResponse && !this.enableCaptha && this.params?.payment?.match('form|rd') && !this.paymentV2.captchaResponse && this.currency !== 'INR') {
      this.toggleCaptcha(true);
      return;
    }
    this.submitForm();
  }

  /**Form submit listener */
  submitForm() {
    if (this.amountForm.valid && this.checkBaseAmtValidity()) {
      const payload = {
        'campaign_id': this.campaignId,
        'currency': this.currency,
        'donated_amount': this.amount,
        'donor_name': this.name.value,
        'donor_email': this.email.value,
        'is_anonymous': this.is_anonymous.value ? '1' : '0',
        'device': this.vars.deviceType,
        'donor_country': this.clientData.country_name,
        'donor_city': this.clientData?.city_name,
        'donor_extension': this.extn || '',
        'donor_phone': this.mobile.value.replace(/\s/g, ''),
        showError: 'false'
      };
      if (this.pincode) {
        payload['donor_pincode'] = this.amountForm.value.pincode;
      }
      if (this.enableCaptha) {
        payload['g-recaptcha-response'] = this.captcha.value;
      }
      if (typeof this.tipAmount === 'number') {
        payload['tip_amount'] = this.tipAmount;
      }
      if ((this.isQR || this.upiMode || this.origin === 'tann' || this.params?.min_donation || (this.origin === 's' && !this.params?.mini_story) || (this.origin === 's' && this.params?.mini_story && this.vwo.min_donation_AB())) && !this.isSipStory) {
        payload['skipmin'] = true;
      }
      if (this.address) {
        payload['donor_address'] = this.amountForm.controls['address'].value;
      }
      if (this.isPanCardExists) {
        payload['pan'] = this.amountForm.value.pancard || '';
      }
      if (this.askPassport) {
        payload['passport'] = this.amountForm.value.passport || '';
      }
      if (this.reward) {
        payload['reward_id'] = this.reward.id;
      }
      if (this.contributeDetails.ask_citizenship && this.config.nationality) {
        payload['indian'] = this.selectedNationality === true ? true : false;
      }
      if (this.isSipCause) {
        payload['split'] = false;
        payload['recurring'] = 1;
        if (this.ngo_sip) {
          payload['ngo_sip'] = 1;
        } else {
          payload['sip_cause'] = this.sipCause.info_3;
        }
      }
      if (this.isSipStory) {
        // payload['transaction_type'] = 'wallet_new_sip_6';
        payload['split'] = false;
        payload['recurring'] = 1;
        payload['cause_amount'] = 1;
        payload['sip_cause'] = [{ sip_cause: this.vars.default_sip_cause, amount: +this.amount }];
      }

      if (this.payment_config?.is_sip) {
        payload['recurring'] = 1;
      }

      // if ((this.vwo.bulk_donationAB() || this.vwo.bulk_donationv1AB() || this.showBulkDonationFor.test(this.params?.utm_medium)) && this.vars.pageName === 'stories' && this.isMobile) {
      // }

      if (this.bulkdata) {
        if (this.vars.selectedHfMiniPlan && (this.user?.last_health_first_order?.order_plan?.status_flag === 1 || this.user?.userHealthPolicy?.status === 1)) {
          this.HfExistAction();
          return false;
        } else {
          payload['bulkdonation'] = this.bulkdata;
          payload['donated_amount'] = this.bulkamount;
        }
      }

      if (this.amount < 1) {
        /**
         * To prevent from entering values less than 1 Rs. (Example in UPI)
         * Also when we set skipmin true we still want user to pay min 1 Rs
         */
        return false;
      }
      if (this.vwo.hf_mini_AB() && !this.params?.sip_story && this.vars.showHfMini && !this.showHfMini) {
        this.showHfMini = true;
        return;
      } else {
        this.showHfMini = false;
      }

      this.sendAmountDetails(payload);
    } else {
      this.utilService.checkValidForm(this.amountForm);
      if (this.enableCaptha && this.captcha && this.captcha.invalid) {
        this.toggleCaptcha(true);
      }
    }
  }

  checkBaseAmtValidity() {
    const amountCheck = new FormControl(this.baseAmount, [
      Validators.required, Validators.pattern(/^[0-9]+$/), Validators.min(this.contributeDetails.min_donation), Validators.max(this.max_donation)
    ]);
    return amountCheck.valid;
  }

  /**Send the order details */
  sendAmountDetails(payload) {
    this.isLoading = true;
    this.paymentService.sendAmount(payload, this.campaignId).subscribe((res: any) => {
      this.failedTransaction = false;
      // this.isLoading = false;
      this.cartResponse = res.data.cart;

      if (this.contributeDetails.ask_citizenship && this.config.nationality) {
        this.cartResponse.indian = this.selectedNationality === true ? true : '0';
      }
      this.paymentUtilService.initaiteQr = true;
      if (this.fromToggleTip) {
        this.pushToggleEvents(payload);
      }
      if (this.isSipCause && !this.ngo_sip) { this.cartResponse['sip_cause'] = this.sipCause.info_3; }
      if (this.isSipCause && this.ngo_sip) { this.cartResponse['ngo_sip'] = 1; }
      this.paymentUtilService.cartResponse.next(this.cartResponse);
      this.paymentV2.paymentConfig.next({ cart: this.cartResponse });
      this.storageService.checkFromSession('cartData', this.cartResponse);
      if (this.vwo.otd_cartdrop_AB) {
        const abandonedCart = {
          show: true,
          link: this.actiRoute.snapshot['_routerState'].url.split('?')[0],
          cart: this.cartResponse,
          fundraiser: this.vars?.fundraiser
        }
        this.vars.abondenedCart.next(abandonedCart);
        this.storageService.check('abandonedCartOtd', abandonedCart);
        this.storageService.delete('abandonedCart');
      }
      if (this.isSipStory || this.payment_config?.is_sip) {
        const cart_data = {
          ...res.data,
          sip_cause_str: this.utilService.jsonToString(payload?.sip_cause),
          timestamp: new Date().getTime()
        }
        this.storageService.checkFromSession('sip_cart', cart_data);
        this.paymentV2.eventForInitiatePayment(11, res.data.campaign, res.data.cart, {});
        this.paymentV2.eventAfterCreatingCart(res.data.campaign, res.data.cart, {});
      } else {
        this.storageService.checkFromSession('cartData', this.cartResponse);
      }
      if (res.data.hasOwnProperty('token')) {
        this.vars.loginMethod = 'cart';
        this.authService.userLogin(res.data).then(() => {
          if (this.vars.selectedHfMiniPlan && (this.user?.last_health_first_order?.order_plan?.status_flag === 1 || this.user?.userHealthPolicy?.status === 1)) {
            this.HfExistAction();
            return;
          }
          if (this.isSipCause || this.isSipStory || (this.ngo_sip && this.isSipCause) || this.payment_config?.is_sip) {
            this.sipRedirection();
            return;
          }
          this.pushEvents();
          this.getPaymentOptions(this.contributeDetails.selected_currency);
          if (this.bulkShown) {
            this.bulkDataEvent();
          }
          this.hfMiniEvent();
        });
      } else {
        if (this.isSipCause || this.isSipStory || (this.ngo_sip && this.isSipCause) || this.payment_config?.is_sip) {
          this.sipRedirection();
          return;
        }
        this.pushEvents();
        this.getPaymentOptions(this.contributeDetails.selected_currency);
        if (this.bulkShown) {
          this.bulkDataEvent();
        }
        this.hfMiniEvent();
      }
      this.addCoupon();
    }, (err) => {
      if (err?.error?.message === `Seems like you're already enrolled in HealthFirst.`) {
        this.HfExistAction();
      } else {
        this.utilService.openSnackBar(err?.error?.message, 'error');
        this.isLoading = false;
      }
      if (this.enableCaptha && this.captcha) {
        this.toggleCaptcha(true);
      }
    });
  }

  bulkDataEvent() {
    if (this.bulkdata) {
      this.eventsService.sendSystemEvent({
        eventName: 'multi_donation',
        info_1: `${JSON.stringify(this.bulkdata)}` || '',
        info_2: this.bulkamount || '',
        info_3: this.vars.selectedHfMiniPlan ? 'healthfirst' : ''
      }).subscribe(_ => _);
      if (this.vars.selectedHfMiniPlan) {
        this.eventsService.claverTapPush('add_healthfirstmini', {});
      }
    } else {
      this.eventsService.sendSystemEvent({
        eventName: 'skip multi_donation',
        info_3: !this.hfExist && this.vwo.bulk_donation_hf_mini_AB() && this.currency === 'INR' ? 'healthfirstmini' : ''
      }).subscribe(_ => _);
    }
  }

  hfMiniEvent() {
    if (this.vars.showHfMini) {
      this.eventsService.sendSystemEvent({
        eventName: this.vars.selectedHfMiniPlan ? 'add_healthfirstmini' : 'without_healthfirstmini',
      }).subscribe(_ => _);
      if (this.vars.selectedHfMiniPlan) {
        this.eventsService.claverTapPush('add_healthfirstmini', {});
      }
    }
  }

  HfExistAction() {
    this.utilService.openSnackBar(`Yay! You're already part of the HealthFirst family!`, 'error');
    this.vars.selectedHfMiniPlan = null;
    if (this.vwo.bulk_donation_hf_mini_AB() && this.bulkdata) {
      delete this.bulkdata[this.vars.hfMiniPlans.id];
      setTimeout(() => {
        this.submitBulk(this.bulkdata);
      }, 100);
    } else if (this.vars.showHfMini) {
      this.bulkdata = null;
      this.vars.showHfMini = false;
      this.submitForm();
    }
    this.hfExist = true;
  }

  sipRedirection() {
    const qparam = {
      currency: this.currency,
      amt: this.amount || '',
      campaign_id: this.campaignId
    };
    if (this.isSipCause && !this.ngo_sip) {
      qparam['sip_cause'] = this.sipCause.info_3;
    }
    if (this.isSipStory) {
      qparam['sip_story'] = 1;
    }
    if (this.ngo_sip) {
      qparam['ngo_sip'] = 1;
    }
    this.dialog.closeAll();
    this.utilService.router.navigate(
      ['/new/sip/payment-standalone'], {
      queryParams: qparam, queryParamsHandling: 'merge'
    }
    );
  }


  addCoupon() {
    if (this.config.utm_nudge && this.paymentUtilService.utmProceedClicked) {
      this.apiService.applyCoupon(this.campaignId, { coupon_id: 59 }).subscribe(res => {
        if (!res.error) {
          // this.paymentUtilService.utmProceedClicked = true;
          // this.dialog.closeAll();
          this.storageService.add('walletOffer100', true);
          // this.utilService.openSnackBar(res.data, 'success');
        }
      }, err => {
        this.storageService.add('walletOffer100', true);
        if (err.error) {
          this.dialog.closeAll();
        }
      });
    }
  }

  /**Get the form details */
  getContributeFormDetails() {
    if (this.contributeDetails.pincode && this.config.pincode) {
      let pattern;
      if (this.contributeDetails.selected_currency === 'INR') {
        pattern = '^[1-9][0-9]{5}$';
      }
      this.askPincode = this.controlToggle('pincode', this.contributeDetails.pincode, pattern);
    }
    if (this.config.anonymous_from_api) {
      this.is_anonymous.setValue(this.contributeDetails.anonymous);
    }
    this.nationalityChange();
    if (this.contributeDetails.address && this.config.address) {
      this.address = this.controlToggle('address', this.contributeDetails.address);
    }
    if (this.contributeDetails.ask_citizenship && this.config.nationality) {
      this.amountForm.addControl('nationality', this.nationality = new FormControl(true, [Validators.required]));
    }
    if (this.isQR && this.isQR.name.match('UPI|Paytm')) {
      this.contributeDetails.min_donation = this.origin === 's' ? 99 : this.contributeDetails.min_donation;
    }
    if (this.params?.min_donation) {
      this.contributeDetails.min_donation = +this.params?.min_donation;
    }
    if (this.isSipStory) {
      this.contributeDetails.min_donation = +this.paymentUtilService.getMinimumAmountOnlySIP(this.contributeDetails.selected_currency);
    }
  }
  /**check if control present Add and remove them */
  controlToggle(name, status, pattern?, value?) {
    const validatorsArray = [Validators.required];
    if (pattern) {
      validatorsArray.push(Validators.pattern(pattern));
    }
    if (status && !this.amountForm.controls[name]) {
      this.amountForm.addControl(name, this[name] = new FormControl(value || '', validatorsArray));
      return true;
    } else if (!status) {
      this.amountForm.removeControl(name);
      return false;
    } else {
      return true;
    }
  }
  /**Get the payment available options from the gateway */
  getPaymentOptions(currency) {
    let params = `&mobile_no=${this.user?.phone_1}&is_mobile=${this.utilService.isMobile() ? 1 : 0}`;
    if (this.bulkdata) {
      params = params.concat(`&amount=${this.cartResponse?.donated_amount}`);
    } else {
      params = params.concat(`&amount=${this.amount}`);
    }
    if (this.upiMode && !this.vwo.paymentV2AB()) {
      params = params.concat(`&mode=UPI`);
    }
    if (this.params['utm_source'] === 'internal_stories_otd_calling') {
      params = params.concat(`&internal_mini_story=1`);
    }
    this.paymentService.getPaymentOptions(currency, params).subscribe({
      next: (res: any) => {
        this.paymentUtilService.paymentOptionsObs.next(res.data);
        this.paymentV2.paymentOptions.next(res.data);
        if (!this.vwo.paymentV2AB()) {
          if (this.upiMode && this.utilService.getMobileOperatingSystem() !== 'iOS') {
            this.submitOrder.next({ mode: this.upiMode.mode, mode_value: this.upiMode.value, payment_gateway: this.upiMode?.payment_gateway || '' });
          }
          if (Object.keys(res.data.options).length === 1) {
            for (const [key] of Object.entries(res.data.options)) {
              const paymentOption = key.charAt(0).toLowerCase();
              this.router.navigate([], {
                queryParams: { payment: 'options', op: paymentOption },
                queryParamsHandling: 'merge'
              });
              if (paymentOption === 'u') {
                this.vars.upiTimerOuter.next(true);
              }
              break;
            }
          } else {
            if (this.vars.isPhonePe) {
              this.paymentUtilService.miniApps.next({ mode: 'CASH', mode_value: 'PHONEPE' });
              this.isLoading = true;
              setTimeout(() => { this.isLoading = false; }, 10000);
            } else if (this.vars.isPaytmMini) {
              this.paymentUtilService.miniApps.next({ mode: 'PAYTMMA', mode_value: 'PAYTM' });
              this.isLoading = true;
              setTimeout(() => { this.isLoading = false; }, 10000);
            } else {
              this.setIsSubmit();
            }
          }
        }
        if (this.paymentFlowType === 'onpage' && !this.failedTransaction) {
          this.paymentUtilService.isSubmitted.next(true);
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
  }
  /**ALL THE EVENT FOR CREATING THE CART FOR THE PAYMENT */
  pushEvents() {
    const data = {
      isLoggedIn: this.isLoading,
      extn: this.extn,
      campaignId: this.campaignId,
      reward: this.reward,
      currency: this.currency,
      amount: this.amount,
      position: this.position,
      info3: this.tipPercent
    };
    if (this.vars.showHFgift && this.currency === 'INR' && this.tipAmount >= this.vars.minTipRequired) {
      data.info3 += ',Coupon Enabled';
    } else if (this.vwo.hf_embedded_ab() && this.vars.showHFgift) {
      data.info3 += ',Coupon Non-Enabled';
    }
    if (this.vars.showHfMini || this.vwo.bulk_donation_hf_mini_AB()) {
      if (this.vars.selectedHfMiniPlan) {
        data.info3 += ',Mini Enabled';
      } else {
        data.info3 += ',Mini Non-Enabled';
      }
    }
    if (this.contributeDetails && this.contributeDetails.slabs) {
      data['slabs'] = this.contributeDetails.slabs;
    }
    this.paymentUtilService.donationFormEvents(this.cartResponse, data, this.onpage);
  }

  /** Adding another event if the user has donated using toggle */
  pushToggleEvents(data) {
    const payload = {
      eventName: 'tip_amount',
      event_type: 'campaign',
      page_name: 'campaign',
      info_1: `${data.tip_amount}/${data.donated_amount}`,
      info_2: data.tip_amount ? 'toggle' : '',
      info_3: 'campaign',
      info_4: ''
    };
    this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
  }

  memorialSipCheck() {
    this.memorialTooltip = !this.isSipCause;
    if (this.isSipCause) {
      this.tipAmount = 0;
      this.amount = this.baseAmount;
    }
    const systemEvent = {
      eventName: this.isSipCause ? 'check monthly giving' : 'Uncheck monthly giving',
      page_name: this.vars.pageName
    };
    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
  }

  independeceAmount = 0;

  setAmountNudge = (e) => {
    if (e > 0) {
      this.independeceAmount = e;
    } else {
      this.independeceAmount = 0;
    }
    this.amount = this.amount + e;
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
